// Boost either body type or price category in tracker rankings
export function boostBuildPreferences(arr, key) {
  const index = arr.indexOf(key);
  if (index !== -1) {
    const [item] = arr.splice(index, 1);
    arr.unshift(item);
  }
  return arr;
}
